module.exports = __webpack_public_path__ + "static/media/galaxy.78097d02.svg";